import React from 'react';

import { TableCell } from '@material-ui/core';
import { CustomRow } from 'interfaces/utils';

export const createTableCellLabels = (customRows: CustomRow[]): JSX.Element[] =>
  customRows.map(({ label, options }, index) => (
    <TableCell
      key={index}
      align={options?.align || index > 0 ? 'right' : 'left'}
    >
      {label}
    </TableCell>
  ));
